export default __webpack_public_path__ + "static/media/volume-banner.6227df15.png";